import { Branding, DisabledPrompt, useBCMSContext, useRoute } from "@bcm-dev/bcms-vite";
import MainContentContainer, { MainContentHeader, MainContentSection } from "components/shared/containers/MainContentContainer";
import SettingsPageWrapper from "components/shared/containers/SettingsPageWrapper";
import BaseRowView from "components/shared/views/BaseRowView";
import React from "react";

import "./styles.css";

/**
 * @function SettingsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for SettingsPage
 */
export default function SettingsPage(props) {
  const navigate = useRoute();
  const globalController = useBCMSContext();
  const isStandalone = globalController.state.branding.options.standalone_chw23  !== "false";
  return (
    <SettingsPageWrapper className="settings-page">
      <MainContentContainer header={<MainContentHeader text="Settings" />}>
        <Branding id="messages_chw23" value="true">
          <BaseRowView mainText="Messages" className="last-row" onClick={() => navigate("/home/messages/0")} dataPoint="Settings_Messages_Link" />
        </Branding>
        <MainContentSection text="General Settings" >
          <Branding id="personal_info_chw23" value="true">
            <BaseRowView mainText="Personal Information" onClick={() => navigate("/settings/personalinformation")} dataPoint="Settings_Personal_Information_Link" />
          </Branding>
          <Branding id="email_preferences_chw23" value="true">
            <DisabledPrompt>
              <BaseRowView mainText="Email Preferences" />
            </DisabledPrompt>
          </Branding>

          <BaseRowView mainText="Hide/Show Cards" onClick={() => navigate("/settings/hideshowcards")} dataPoint="Settings_Hide_Show_Link"/>

          <Branding id="change_password_chw23" value="true">
            <DisabledPrompt>
              <BaseRowView mainText="Change Password" />
            </DisabledPrompt>
          </Branding>

        </MainContentSection>
        <Branding id="settings_others_chw23" value="true">
          <MainContentSection text="Others" >
            <DisabledPrompt>
              <BaseRowView mainText="Contact Us" />
            </DisabledPrompt>
            <DisabledPrompt>
              <BaseRowView mainText="Terms and Conditions" />
            </DisabledPrompt>
            <DisabledPrompt>
              <BaseRowView mainText="Privacy Policy" />
            </DisabledPrompt>
            {!isStandalone&& <DisabledPrompt>
              <BaseRowView mainText="Log Out" />
            </DisabledPrompt>
            }
             {isStandalone&& 
            
          <BaseRowView mainText="Log Out" onClick={() => navigate("/login")} />

            
            }
          </MainContentSection>
        </Branding>
      </MainContentContainer>
    </SettingsPageWrapper>
  );
}